import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MenuPortaleComponent } from '../components/menu-portale.component';
import { SectionTitleComponent } from '../components/section-title.component';
import { ScaricaAppComponent } from '../components/scarica-app.component';
import { PortaleLayoutFooterComponent } from '../../layout/portale-layout-footer/portale-layout-footer.component';

@Component({
    selector: 'app-scopri',
    templateUrl: './scopri.component.html',
    styleUrls: ['../../../lib/themes/portale.theme.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MenuPortaleComponent, SectionTitleComponent, ScaricaAppComponent, PortaleLayoutFooterComponent]
})
export class ScopriComponent {

}
